import React from "react";

import RbSelectField from "components/RbSelectField";

const statusOptions = [
  { value: "COMPLETED", label: "Completed" },
  { value: "PENDING", label: "Pending" },
];

function ProductStatusSelect(props) {
  return <RbSelectField options={statusOptions} {...props} />;
}

export default React.memo(ProductStatusSelect);
